// Share the instance module in the next-shared layer
import { workAsyncStorage } from './work-async-storage-instance' with {
    'turbopack-transition': 'next-shared'
};
export { workAsyncStorage };

//# sourceMappingURL=work-async-storage.external.js.map